import * as React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { CompositeProductInfoCfgUIElementState } from '@/stores/CompositeProductInfoCfgUIElementState';
import classNames from 'classnames';

interface CompositeProductInfoUIElementProps {
  state: CompositeProductInfoCfgUIElementState;
}

export const CompositeProductInfoUIElement = observer(function ({ state }: CompositeProductInfoUIElementProps) {
  const { t: tTranslation } = useTranslation('translation');
  const viewElement = state.viewElement;

  return (
    <div className={'cp-composite-product-info'} data-element-id={viewElement.id}>
      {viewElement.showTitle && state.title && (
        <h2 data-main-title className={classNames('cp-composite-product-info__title')}>
          {state.title}
        </h2>
      )}
      {viewElement.showShortDescription && state.shortDescription && (
        <div className={'cp-composite-product-info__short-description'}>{state.shortDescription}</div>
      )}

      {viewElement.showDescription && state.description && (
        <div className={'cp-composite-product-info__description'}>{state.description}</div>
      )}
    </div>
  );
});
